import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, FormFeedback } from '@prism/form';
import Icon from '@prism/icon';
import { Label } from '@prism/input';
import InputGroup from '@prism/inputgroup';
import ReactDatePicker from 'react-datepicker';
import classnames from 'classnames';
import { min, max, isValid } from 'date-fns';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var generateHeaderTitle = function generateHeaderTitle(date) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  return "".concat(date.toLocaleString(locale, {
    month: 'long'
  }), " ").concat(date.getFullYear());
};

var Header = function Header(props) {
  var decreaseMonth = props.decreaseMonth,
      decreaseYear = props.decreaseYear,
      increaseMonth = props.increaseMonth,
      increaseYear = props.increaseYear,
      isMonthPicker = props.isMonthPicker,
      selectedDate = props.selectedDate,
      showMonthPicker = props.showMonthPicker;
  var currentSelectedDate = new Date(selectedDate);

  if (isMonthPicker) {
    return /*#__PURE__*/React.createElement("div", {
      className: "picker-header-navigation"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: decreaseYear,
      className: "navigation-button link",
      "aria-label": "decrease-year"
    }, /*#__PURE__*/React.createElement("i", {
      className: "icon prism-icon-chevron-left"
    })), /*#__PURE__*/React.createElement("div", {
      className: "current-month"
    }, currentSelectedDate.getFullYear()), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: increaseYear,
      className: "navigation-button link",
      "aria-label": "increase-year"
    }, /*#__PURE__*/React.createElement("i", {
      className: "icon prism-icon-chevron-right"
    })));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "picker-header-navigation"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: decreaseMonth,
    className: "navigation-button link",
    "aria-label": "decrease-month"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon prism-icon-chevron-left-light"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: showMonthPicker,
    className: "current-month link",
    "aria-label": "month-picker"
  }, generateHeaderTitle(currentSelectedDate)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: increaseMonth,
    className: "navigation-button link",
    "aria-label": "increase-month"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon prism-icon-chevron-right-light"
  })));
};

Header.propTypes = {
  decreaseMonth: PropTypes.func.isRequired,
  decreaseYear: PropTypes.func.isRequired,
  increaseMonth: PropTypes.func.isRequired,
  increaseYear: PropTypes.func.isRequired,
  isMonthPicker: PropTypes.bool,
  selectedDate: PropTypes.instanceOf(Date),
  showMonthPicker: PropTypes.func.isRequired
};
Header.defaultProps = {
  isMonthPicker: false,
  selectedDate: new Date()
};
Header.displayName = 'DatePicker.Header';

/**
 * Converts `date` to a Date object
 *
 * @param {Date | string} date
 * @returns Date
 */

var toDate = function toDate(date) {
  if (date) {
    var d = new Date(date);
    return isValid(d) ? d : new Date();
  }

  return new Date();
};
/**
 * Constrain the date between the min and maximum date
 * @param {Date} date
 * @param {object} options
 * @param {Date} options.min minimum date
 * @param {Date} options.max maximum date
 * @returns
 */

var constrainDate = function constrainDate(date, _ref) {
  var _ref$min = _ref.min,
      min$1 = _ref$min === void 0 ? new Date(-8640000000000000) : _ref$min,
      _ref$max = _ref.max,
      max$1 = _ref$max === void 0 ? new Date(8640000000000000) : _ref$max;
  return min([max([date, min$1]), max$1]);
};
/**
 * Returns a new Function-wrapper that first executes preventDefault on the event argument
 *   and then runs the initial function.
 * @param {Function} func for wrapping
 * @returns Function
 */

var preventDefaultEvent = function preventDefaultEvent(func) {
  return function (e) {
    e.preventDefault();

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    func.apply(void 0, [e].concat(args));
  };
};

var _excluded = ["afterCalendarClose", "afterClickOutside", "className", "datePickerRef", "defaultValue", "readonly", "disabled", "endDate", "forceShowDate", "hasMessage", "inputClassName", "invalid", "label", "maxDate", "minDate", "nullAllowed", "onChange", "placeholder", "selectsRange", "size", "startDate", "triggerClassName", "valid"];

var useDatePicker = function useDatePicker(props) {
  var _classnames, _classnames2, _classnames3;

  var afterCalendarClose = props.afterCalendarClose,
      afterClickOutside = props.afterClickOutside,
      className = props.className,
      datePickerRef = props.datePickerRef,
      defaultValue = props.defaultValue,
      readonly = props.readonly,
      disabled = props.disabled,
      initialEndDate = props.endDate;
      props.forceShowDate;
      var hasMessage = props.hasMessage,
      inputClassName = props.inputClassName,
      invalid = props.invalid;
      props.label;
      var maxDate = props.maxDate,
      minDate = props.minDate,
      nullAllowed = props.nullAllowed,
      onChange = props.onChange,
      placeholder = props.placeholder,
      selectsRange = props.selectsRange,
      size = props.size,
      initialStartDate = props.startDate,
      triggerClassName = props.triggerClassName,
      valid = props.valid,
      attrs = _objectWithoutProperties(props, _excluded);

  var parsedMinDate = toDate(minDate);
  var parsedMaxDate = toDate(maxDate);
  var dateValue = constrainDate(toDate(defaultValue), {
    min: parsedMinDate,
    max: parsedMaxDate
  });
  var minSelectableMonth = new Date(parsedMinDate).setDate(1);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMonthPicker = _useState2[0],
      setIsMonthPicker = _useState2[1];

  var _useState3 = useState(dateValue),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedDate = _useState4[0],
      setSelectedDate = _useState4[1];

  var _useState5 = useState(function () {
    if (initialStartDate === null) {
      return [null, null];
    }

    var computedStartDate = new Date(initialStartDate);

    if (initialEndDate === null) {
      return [computedStartDate, null];
    }

    var computedEndDate = new Date(initialEndDate);

    if (computedStartDate <= computedEndDate) {
      return [computedStartDate, computedEndDate];
    }

    return [null, null];
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      dateRange = _useState6[0],
      setDateRange = _useState6[1];

  var _dateRange = _slicedToArray(dateRange, 2),
      startDate = _dateRange[0],
      endDate = _dateRange[1];

  var handleClickOutside = function handleClickOutside() {
    setIsMonthPicker(false);

    if (afterClickOutside) {
      afterClickOutside();
    }
  };

  var handleCalendarClose = function handleCalendarClose() {
    setIsMonthPicker(false);

    if (afterCalendarClose) {
      afterCalendarClose();
    }
  };

  var handleDateChange = function handleDateChange(date) {
    var newDate = date === null && nullAllowed ? null : constrainDate(toDate(date), {
      min: parsedMinDate,
      max: parsedMaxDate
    });
    setIsMonthPicker(false);
    setSelectedDate(newDate);
    onChange(newDate);
  };

  var handleDateRangeChange = function handleDateRangeChange(update) {
    var newDateRange = update || [null, null];

    if (!isMonthPicker) {
      setDateRange(newDateRange);
    }

    setIsMonthPicker(false);
    onChange(newDateRange);

    var _newDateRange = _slicedToArray(newDateRange, 2),
        newStartDate = _newDateRange[0],
        newEndDate = _newDateRange[1];

    if (newStartDate && newEndDate) {
      datePickerRef.current.setOpen(false);
    }
  };

  var computedClassName = classnames((_classnames = {
    'date-picker': true,
    picker: true
  }, _defineProperty(_classnames, "picker-".concat(size), size === 'sm'), _defineProperty(_classnames, 'picker--range', selectsRange), _defineProperty(_classnames, className, className), _defineProperty(_classnames, 'has-message', !!hasMessage), _defineProperty(_classnames, 'is-valid', !!valid), _defineProperty(_classnames, 'is-invalid', !!invalid), _classnames));
  var computedInputClassName = classnames((_classnames2 = {
    'date-picker-input': true,
    'form-control': true,
    'inset-right': true
  }, _defineProperty(_classnames2, "form-control-".concat(size), size === 'sm'), _defineProperty(_classnames2, inputClassName, inputClassName), _defineProperty(_classnames2, 'is-valid', valid), _defineProperty(_classnames2, 'is-invalid', invalid), _defineProperty(_classnames2, 'has-validation', !!hasMessage), _defineProperty(_classnames2, 'is-readonly', readonly), _defineProperty(_classnames2, "clearable", selectsRange && startDate), _classnames2));
  var computedTriggerClassName = classnames((_classnames3 = {
    'date-picker-trigger': true,
    btn: true,
    'input-group-action': true
  }, _defineProperty(_classnames3, "btn-".concat(size), size === 'sm'), _defineProperty(_classnames3, triggerClassName, triggerClassName), _classnames3));
  var computedPlaceholder = placeholder || (selectsRange ? 'Select date range' : 'MM/DD/YYYY');

  var computeInputValue = function computeInputValue() {
    if (selectsRange) {
      if (!startDate && !endDate) {
        return '';
      }

      var startDateValue = (startDate === null || startDate === void 0 ? void 0 : startDate.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })) || '';
      var endDateValue = (endDate === null || endDate === void 0 ? void 0 : endDate.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })) || '';
      return "".concat(startDateValue, " - ").concat(endDateValue);
    }

    return selectedDate;
  };

  var renderCustomHeader = function renderCustomHeader(_ref) {
    var date = _ref.date,
        decreaseMonth = _ref.decreaseMonth,
        decreaseYear = _ref.decreaseYear,
        increaseMonth = _ref.increaseMonth,
        increaseYear = _ref.increaseYear;
    return /*#__PURE__*/React.createElement(Header, {
      selectedDate: date,
      isMonthPicker: isMonthPicker,
      decreaseYear: preventDefaultEvent(decreaseYear),
      increaseYear: preventDefaultEvent(increaseYear),
      decreaseMonth: preventDefaultEvent(decreaseMonth),
      increaseMonth: preventDefaultEvent(increaseMonth),
      showMonthPicker: function showMonthPicker() {
        return setIsMonthPicker(true);
      }
    });
  };

  var datePickerProps = _objectSpread2(_objectSpread2({}, attrs), {}, {
    className: computedInputClassName,
    disabled: disabled,
    isClearable: selectsRange && startDate,
    formatWeekDay: function formatWeekDay(dayOfWeekLabel) {
      return dayOfWeekLabel.substring(0, 1);
    },
    maxDate: parsedMaxDate,
    minDate: isMonthPicker ? minSelectableMonth : parsedMinDate,
    onClickOutside: handleClickOutside,
    onCalendarClose: handleCalendarClose,
    onChange: selectsRange ? handleDateRangeChange : handleDateChange,
    openToDate: selectedDate ? selectedDate : dateValue,
    placeholderText: computedPlaceholder,
    readOnly: readonly,
    ref: datePickerRef,
    renderCustomHeader: renderCustomHeader,
    selectsRange: selectsRange,
    shouldCloseOnSelect: !selectsRange && !isMonthPicker,
    showMonthYearPicker: isMonthPicker,
    value: computeInputValue(),
    // single date picker
    selected: selectsRange ? false : selectedDate,
    // date range picker
    startDate: selectsRange ? startDate : false,
    endDate: selectsRange ? endDate : false
  });

  return {
    className: computedClassName,
    triggerClassName: computedTriggerClassName,
    datePickerProps: datePickerProps,
    isMonthPicker: isMonthPicker
  };
};

var DatePicker = function DatePicker(props) {
  var label = props.label,
      size = props.size,
      readonly = props.readonly,
      disabled = props.disabled,
      invalid = props.invalid;
  var datePickerRef = useRef(null);
  var hasMessage = typeof invalid === 'string';

  var _useDatePicker = useDatePicker(_objectSpread2(_objectSpread2({}, props), {}, {
    datePickerRef: datePickerRef,
    hasMessage: hasMessage
  })),
      computedClassName = _useDatePicker.className,
      computedTriggerClassName = _useDatePicker.triggerClassName,
      datePickerProps = _useDatePicker.datePickerProps;

  var handleClickIcon = function handleClickIcon(e) {
    e.preventDefault(); // Open date picker

    datePickerRef.current.setOpen(true);
  };

  return /*#__PURE__*/React.createElement(FormGroup, {
    className: computedClassName,
    "aria-label": "date-picker"
  }, label && /*#__PURE__*/React.createElement(Label, {
    fontSize: size
  }, label), /*#__PURE__*/React.createElement(InputGroup, null, /*#__PURE__*/React.createElement(ReactDatePicker, datePickerProps), !readonly && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: computedTriggerClassName,
    onClick: handleClickIcon,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "calendar"
  })), invalid && hasMessage && /*#__PURE__*/React.createElement(FormFeedback, null, /*#__PURE__*/React.createElement(Icon, {
    glyph: "notification-circle",
    className: "small mr-1"
  }), invalid)));
};

var DatePickerSizes = ['sm', 'lg'];
DatePicker.propTypes = {
  afterClickOutside: PropTypes.func,
  afterCalendarClose: PropTypes.func,
  className: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  disabled: PropTypes.bool,
  endDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string, PropTypes.instanceOf(null)]),
  forceShowDate: PropTypes.bool,
  inputClassName: PropTypes.string,
  invalid: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  label: PropTypes.string,
  maxDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  minDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  nullAllowed: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  selectsRange: PropTypes.bool,
  size: PropTypes.oneOf(DatePickerSizes),
  startDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string, PropTypes.instanceOf(null)]),
  triggerClassName: PropTypes.string,
  valid: PropTypes.bool,
  readonly: PropTypes.bool
};
DatePicker.defaultProps = {
  afterClickOutside: null,
  afterCalendarClose: null,
  className: undefined,
  defaultValue: null,
  disabled: false,
  endDate: null,
  forceShowDate: false,
  inputClassName: undefined,
  invalid: false,
  label: undefined,
  maxDate: new Date('12/31/9999'),
  minDate: new Date(null),
  nullAllowed: false,
  onChange: function onChange() {},
  placeholder: undefined,
  selectsRange: false,
  size: 'lg',
  startDate: null,
  triggerClassName: undefined,
  valid: false,
  readonly: false
};
DatePicker.displayName = 'DatePicker';

DatePicker.Header = Header;

export { Header as DatePickerHeader, DatePickerSizes, DatePicker as default };
//# sourceMappingURL=index.js.map
